import { useEffect, useState } from 'react';

import { ChatResponse } from '@ariksa/ai-engine/api';
import { Stack } from '@chakra-ui/react';
import { orderBy } from 'lodash';

import { SearchIcon } from 'components/Icons';
import { AriksaLogoOnlyIcon } from 'components/Icons/ReactCustomIcons/AriksaLogoOnlyIcon';
import { Tabs } from 'components/Navigation';
import { Assistant } from 'containers/ConversationalAI/Components/AiAssistant/Assistant';
import { AllReferences } from 'containers/ConversationalAI/Components/AiAssistant/References/AllReferences';

interface BotResponseProps {
  item: ChatResponse & {
    query?: string;
    ai_search?: string;
  };
}

export const BotResponse = (props: BotResponseProps) => {
  const { ui_redirection_link } = props.item;
  const [references, setReferences] = useState<Record<string, any>[]>([]);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    setReferences(orderBy(ui_redirection_link?.references, ['score'], 'desc'));
  }, [ui_redirection_link?.references]);

  return (
    <Stack
      bg={'#fff'}
      borderRadius={6}
      p={6}
      px={6}
      spacing={6}
      boxShadow={'0 1px 2px rgba(0, 0, 0, 0.1)'}
      w="full"
    >
      {/*<HStack>
        <Square size={6}>
          <AriksaLogoOnlyIcon />
        </Square>
        <Box>ASSISTANT</Box>
      </HStack>
      <Assistant
        item={{ ...props.item, references }}
        setTabIndex={setTabIndex}
      />*/}
      <Tabs
        items={[
          {
            title: 'ASSISTANT',
            icon: <AriksaLogoOnlyIcon />,
            component: (
              <Assistant
                item={{ ...props.item, references }}
                setTabIndex={setTabIndex}
              />
            ),
            key: 'assistant',
            styles: { iconSize: 7, iconColor: '#000' },
          },
          ...(!!references?.length
            ? [
                {
                  title: 'REFERENCES',
                  icon: <SearchIcon />,
                  component: <AllReferences references={references} />,
                  key: 'references',
                  styles: { iconSize: 5, iconColor: '#000' },
                },
              ]
            : []),
        ]}
        currentIndex={tabIndex}
        onChange={setTabIndex}
        styles={{
          tab: {
            fontSize: 'sm',
            stack: { direction: 'row' },
            _selected: {
              color: '#000',
              borderBottomColor: 'primary',
              fontWeight: 400,
            },
          },
        }}
      />
    </Stack>
  );
};
